module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4tznu"))).then(() => parcelRequire('d0iPb'));